module.exports = __webpack_public_path__ + "baecb90c09ee7d298147cdf096aec8ae.svg";